import { computed } from 'vue';
import { useStore } from 'vuex';
import yup from '@component_path/inquiry_form_common_module/customValidation';

export const usePrefectureIdField = (required, messages = {}) => {
  const fieldName = computed(() => 'prefecture_id');

  const validator = yup
    .number()
    .integer()
    .typeError(messages['requirement'] || '都道府県は必須項目です')
    .requirement(required, messages['requirement'] || '都道府県は必須項目です');

  return { fieldName, validator };
};

export const usePrefectureIdStore = () => {
  const store = useStore();
  const prefectureId = computed(() => store.state.formData.prefecture_id);
  const prefectures = computed(() => store.state.masterData.prefectures);
  const prefecture = computed(() =>
    prefectures.value.find(pref => pref.value === prefectureId.value)
  );
  const dispatcher = computed(() => 'formData/setPrefectureId');

  const prefectureText = computed(() => {
    const prefecture = store.state.masterData.prefectures.find(
      prefecture => prefecture.value === store.state.formData.prefecture_id
    );
    return prefecture ? prefecture.label : '';
  });

  return { prefectureId, prefectures, prefecture, prefectureText, dispatcher };
};
